export function findFirst(arr) {
  return arr.find(Boolean);
}
export var contains = function contains(arr, value) {
  return arr.includes(value);
};